import { render, staticRenderFns } from "./Exhibit.vue?vue&type=template&id=034df8b7"
import script from "./Exhibit.vue?vue&type=script&lang=js"
export * from "./Exhibit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports